module.exports = __webpack_public_path__ + "img/600m.09ad6e77.png";